import { t } from "i18next"
import { z } from "zod"
import { stringRequired } from "@/models/common"
import { PregnantStatus, RequestExamination } from "@/types/__generated__/union-types"

const CLINICAL_ASSESSMENT_MAX_LENGTH = 500
const QUESTION_MAX_LENGTH = 250
const EMPLOYER_MAX_LENGTH = 25

const MeasRadiologyPrescriptionSchema = z.object({
  language: z.custom<"GERMAN">((language) => !!language, {
    message: "common.fieldErrorList.requiredField",
  }),
  requestExaminations: z.array(z.custom<RequestExamination>()).min(1, {
    message: "common.fieldErrorList.requiredField",
  }),
  clinicalAssessment: stringRequired.max(CLINICAL_ASSESSMENT_MAX_LENGTH, {
    message: t("common.fieldErrorList.characterLimit"),
  }),
  question: stringRequired.max(QUESTION_MAX_LENGTH, {
    message: t("common.fieldErrorList.characterLimit"),
  }),
  pregnantStatus: z.custom<PregnantStatus>().refine((value) => Boolean(value), "common.fieldErrorList.requiredField"),
  employer: stringRequired.max(EMPLOYER_MAX_LENGTH, { message: "common.fieldErrorList.characterLimit" }),
})

type MeasRadiologyPrescription = z.infer<typeof MeasRadiologyPrescriptionSchema>

export {
  type MeasRadiologyPrescription,
  MeasRadiologyPrescriptionSchema,
  CLINICAL_ASSESSMENT_MAX_LENGTH,
  QUESTION_MAX_LENGTH,
  EMPLOYER_MAX_LENGTH,
}
